export default __webpack_public_path__ + "static/media/our-partner-logo-2.9e54b369.svg";